import { ITemplateDB, ITemplateList } from '../models';

export function mapTemplateList(list: ITemplateDB[]): ITemplateList {
	return list.map(({ id, name, editable, quick }) => ({
		id,
		name,
		isEditable: editable,
		isQuick: quick,
	}));
}
